'use strict';

var novicell = novicell || {};

novicell.subNavigation = novicell.subNavigation || new function () {

    this.init = function (siteNavigationList) {
        var subNavToggles = siteNavigationList.querySelectorAll('.js-sub-navigation-toggle');

        if (!subNavToggles) {
            return;
        }

        for (var i = 0; i < subNavToggles.length; i++) {
            var currentToggle = subNavToggles[i];

            currentToggle.addEventListener('click', clickToggle);
        }
    };

};

function clickToggle(elem) {
    elem.preventDefault();
    var toggle = elem.currentTarget;
    var toggleParent = toggle.parentNode;

    if (!toggleParent) {
        return;
    }

    var subNav = toggleParent.querySelector('.js-sub-navigation');

    /* novicell.helper.toggleClass(subNav, 'sub-navigation--open'); */
    novicell.helper.toggleClass(toggleParent, 'site-navigation-list__item--open');

    let openSubNavs = toggleParent.querySelectorAll('.site-navigation-list__item--open');

    for (let i = 0; i < openSubNavs.length; i++) {
        const el = openSubNavs[i];
        el.classList.remove('site-navigation-list__item--open');
    }
}
